(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2085],{

/***/ 54073:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(29259),
    now = __webpack_require__(61100),
    toNumber = __webpack_require__(7642);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 61100:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(37772);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 12436:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var debounce = __webpack_require__(54073),
    isObject = __webpack_require__(29259);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 40307:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hospitals",
      function () {
        return __webpack_require__(6608);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 27441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(89961);
/* harmony import */ var _components_atom_icon_arrow_BreadCrumbArrow__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18138);
/* harmony import */ var _constants_url__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26093);
/* harmony import */ var _constants_zIndex__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31591);
/* harmony import */ var _styles_layout__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(64952);
/* harmony import */ var _types_common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70138);
/* harmony import */ var _types_magazine__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45162);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(78287);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  visibility: ",
        ";\n  position: ",
        ";\n  display: flex;\n\n  @media screen and (max-width: ",
        ") {\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  svg {\n    margin: 0 2px;\n  }\n  p:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px 24px 0;\n  position: relative;\n  z-index: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}












var BreadCrumbs = function(param) {
    var visible = param.visible, path = param.path, type = param.type, name = param.name, urlParameter = param.urlParameter;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var paths = path.split("/").filter(function(item) {
        return item !== "content";
    });
    var breadCrumbPath = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(detailPath) {
        if (detailPath === "") {
            return {
                label: "홈",
                url: "/",
                logName: "home"
            };
        }
        if (path.includes("community")) {
            if (detailPath === "setting") {
                return {
                    label: "설정",
                    url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.COMMUNITY.SETTING.path */ .Z6.COMMUNITY.SETTING.path),
                    logName: "community_setting"
                };
            }
            if (detailPath === "write") {
                return {
                    label: "글쓰기",
                    url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.COMMUNITY.WRITE.path */ .Z6.COMMUNITY.WRITE.path),
                    logName: "community_write"
                };
            }
            if (detailPath === "comment") {
                var pid = path.split("/");
                return {
                    label: "대댓글",
                    url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.COMMUNITY.COMMENT.path */ .Z6.COMMUNITY.COMMENT.path, "/").concat(pid[pid.length - 1]),
                    logName: "community_comment"
                };
            }
            if (detailPath === "community") {
                return {
                    label: "커뮤니티",
                    url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.COMMUNITY.LIST.path */ .Z6.COMMUNITY.LIST.path),
                    logName: "community_list"
                };
            }
            if (detailPath === "list") {
                return {
                    label: name,
                    url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.COMMUNITY.LIST.path */ .Z6.COMMUNITY.LIST.path).concat(urlParameter),
                    logName: "community_list_category"
                };
            }
        }
        if (detailPath === "qna") {
            return {
                label: "실시간 의료상담",
                url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.QNA.REALTIME.path */ .Z6.QNA.REALTIME.path,
                logName: "qna_list"
            };
        }
        if (detailPath === "realtime") {
            return {
                label: name,
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.QNA.REALTIME.path */ .Z6.QNA.REALTIME.path).concat(urlParameter),
                logName: "qna_list_category"
            };
        }
        if (detailPath === "write") {
            return {
                label: "질문 작성",
                url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.QNA.WRITE.path */ .Z6.QNA.WRITE.path,
                logName: "qna_write"
            };
        }
        if (detailPath === "nps") {
            return {
                label: "의견 전하기",
                url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.QNA.NPS.path */ .Z6.QNA.NPS.path,
                logName: "qna_nps"
            };
        }
        if (path.includes("author")) {
            if (detailPath === "author") {
                return {
                    label: "에디터",
                    url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.MAGAZINE.HOME.path */ .Z6.MAGAZINE.HOME.path,
                    logName: "magazine_list"
                };
            }
            return {
                label: name,
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.AUTHOR.DETAIL.path */ .Z6.AUTHOR.DETAIL.path, "/").concat(urlParameter),
                logName: "magazine_list"
            };
        }
        if (path.includes("magazine")) {
            if (detailPath === "magazine") {
                return {
                    label: "건강 매거진",
                    url: _constants_url__WEBPACK_IMPORTED_MODULE_6__/* .Urls.Magazine */ .n.Magazine,
                    logName: "magazine_list"
                };
            }
            return {
                label: name,
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.MAGAZINE.DETAIL.path */ .Z6.MAGAZINE.DETAIL.path, "/").concat(urlParameter),
                logName: "magazine_list"
            };
        }
        if (path.includes("faq")) {
            if (detailPath === "faq") {
                return {
                    label: "1분 FAQ",
                    url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.FAQ.LIST.path */ .Z6.FAQ.LIST.path,
                    logName: "faq_list"
                };
            }
            return {
                label: name,
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.FAQ.DETAIL.path */ .Z6.FAQ.DETAIL.path, "/").concat(urlParameter),
                logName: "faq_list"
            };
        }
        if (detailPath === "mypage") {
            return {
                label: "마이페이지",
                url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.COMMON.MYPAGE.path */ .Z6.COMMON.MYPAGE.path,
                logName: "mypage"
            };
        }
        if (path.includes("hospitals")) {
            if (detailPath.includes("search")) {
                return {
                    label: "검색 결과",
                    url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.HOSPITAL.DETAIL.path */ .Z6.HOSPITAL.DETAIL.path).concat(detailPath),
                    logName: "hospitals_search"
                };
            }
            if (detailPath.includes("sub-category")) {
                return {
                    label: "검색 결과",
                    url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.HOSPITAL.HOME.path */ .Z6.HOSPITAL.HOME.path, "/").concat(detailPath),
                    logName: "hospitals_subcategory"
                };
            }
            if (detailPath.includes("neighborhood")) {
                return {
                    label: "지역별 병원 정보",
                    url: path,
                    logName: "hospitals_neighborhood"
                };
            }
            return {
                label: "병원 찾기",
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.HOSPITAL.HOME.path */ .Z6.HOSPITAL.HOME.path),
                logName: "hospitals"
            };
        }
        if (path.includes("medicine-dictionary")) {
            if (detailPath === "search") {
                return {
                    label: "검색 결과",
                    url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.MEDICINE_DICTIONARY.SEARCH.path */ .Z6.MEDICINE_DICTIONARY.SEARCH.path),
                    logName: "medicine_dictionary_search_result"
                };
            }
            return {
                label: "의약품 사전",
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.MEDICINE_DICTIONARY.HOME.path */ .Z6.MEDICINE_DICTIONARY.HOME.path),
                logName: "medicine_dictionary_list"
            };
        }
        if (path.includes("disease-encyclopedia")) {
            if (detailPath === "select-subject") {
                return {
                    label: "과목 선택",
                    url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.DISEASE_ENCYCLOPEDIA.SELECT_SUBJECT.path */ .Z6.DISEASE_ENCYCLOPEDIA.SELECT_SUBJECT.path,
                    logName: "disease_encyclopedia_select_subject"
                };
            }
            if (detailPath === "total") {
                return {
                    label: "전체 질환",
                    url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.DISEASE_ENCYCLOPEDIA.SELECT_SUBJECT.path */ .Z6.DISEASE_ENCYCLOPEDIA.SELECT_SUBJECT.path,
                    logName: "disease_encyclopedia_select_subject"
                };
            }
            if (detailPath === "search") {
                return {
                    label: "검색 결과",
                    url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.DISEASE_ENCYCLOPEDIA.SEARCH.path */ .Z6.DISEASE_ENCYCLOPEDIA.SEARCH.path,
                    logName: "disease_encyclopedia_search"
                };
            }
            return {
                label: "질환백과",
                url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.DISEASE_ENCYCLOPEDIA.HOME.path */ .Z6.DISEASE_ENCYCLOPEDIA.HOME.path,
                logName: "disease_encyclopedia_list"
            };
        }
        if (detailPath === "search") {
            return {
                label: "통합검색",
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.SEARCH */ .Z6.SEARCH().HOME.path),
                logName: "integrated_search"
            };
        }
        if (detailPath === "list") {
            return {
                label: "전체",
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.MAGAZINE.LIST.path */ .Z6.MAGAZINE.LIST.path, "/").concat(_types_magazine__WEBPACK_IMPORTED_MODULE_9__/* .MagazineType.INTERNAL */ .rL.INTERNAL),
                logName: "magazine_list"
            };
        }
        if (detailPath.includes("tag")) {
            var tag = detailPath.split("=");
            return {
                label: decodeURI(tag[1]),
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.MAGAZINE.HOME.path */ .Z6.MAGAZINE.HOME.path, "/").concat(detailPath),
                logName: "magazine_list_tags"
            };
        }
        if (detailPath === "non-benefit") {
            return {
                label: "우리동네 진료 가격",
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.NON_BENEFIT.HOME.path */ .Z6.NON_BENEFIT.HOME.path),
                logName: "non_benefit_home"
            };
        }
        if (detailPath.includes("map")) {
            return {
                label: "최저가 약국 찾기",
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.NON_BENEFIT.MAP.path */ .Z6.NON_BENEFIT.MAP.path),
                logName: "non_benefit_map"
            };
        }
        if (name) {
            return {
                label: name,
                url: type === "qna" ? "".concat(_constants_url__WEBPACK_IMPORTED_MODULE_6__/* .Urls.QnaCategory */ .n.QnaCategory, "/").concat(detailPath) : "".concat(_constants_url__WEBPACK_IMPORTED_MODULE_6__/* .Urls.MagazineCategory */ .n.MagazineCategory, "/list/").concat(detailPath),
                logName: "ctg"
            };
        }
        return {
            label: decodeURI(decodeURIComponent(detailPath)),
            url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.MAGAZINE.LIST.path */ .Z6.MAGAZINE.LIST.path, "/").concat(detailPath),
            logName: "magazine_list_tags"
        };
    }, [
        name,
        path,
        type
    ]);
    var breadCrumb = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return paths.map(function(path) {
            return breadCrumbPath(path);
        }).filter(function(item) {
            return item !== null;
        });
    }, [
        breadCrumbPath,
        paths
    ]);
    var onClickBreadCrumb = function(name) {
        (0,_utils_logger__WEBPACK_IMPORTED_MODULE_10__/* .logger */ .kg)({
            pageName: (0,_utils_logger__WEBPACK_IMPORTED_MODULE_10__/* .getPageName */ .j0)(router),
            eventName: "breadcrumb_".concat(name, "_click")
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        visible: visible,
        id: "breadcrumbs",
        children: breadCrumb.map(function(item, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Path, {
                role: "button",
                onClick: function() {
                    return onClickBreadCrumb(item.logName);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: item.url,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                children: item.label
                            })
                        })
                    }),
                    index !== breadCrumb.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_icon_arrow_BreadCrumbArrow__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                ]
            }, item.label);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumbs);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-97c0c0ce-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
}, function(param) {
    var visible = param.visible;
    return visible ? "visible" : "hidden";
}, function(param) {
    var visible = param.visible;
    return visible ? "static" : "absolute";
}, _styles_layout__WEBPACK_IMPORTED_MODULE_12__/* .Tablet */ .YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI14R;
});
var Path = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-97c0c0ce-1"
})(_templateObject1());
var BreadCrumbsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-97c0c0ce-2"
})(_templateObject2(), _constants_zIndex__WEBPACK_IMPORTED_MODULE_7__/* .zIndex.BreadCrumb */ .W.BreadCrumb);
BreadCrumbs.Wrapper = BreadCrumbsWrapper;


/***/ }),

/***/ 70253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

var HeaderSearch = function(param) {
    var _size = param.size, size = _size === void 0 ? 20 : _size, _fill = param.fill, fill = _fill === void 0 ? "#A9AEB1" : _fill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_2367_13371)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8.14439 0.00740448C6.96401 0.0621085 5.82582 0.358628 4.75176 0.89126C3.71218 1.40678 2.80897 2.1128 2.03838 3.0122C1.20773 3.98172 0.584464 5.18337 0.265416 6.43052C-0.088472 7.81385 -0.088472 9.30318 0.265416 10.6865C0.516512 11.668 0.962352 12.6367 1.54676 13.4705C1.95391 14.0514 2.45622 14.6026 3.01408 15.0805C3.9275 15.8631 5.04158 16.4594 6.21639 16.7946C7.37532 17.1252 8.62415 17.2049 9.83639 17.0255C11.0486 16.8462 12.2452 16.3869 13.2724 15.7065C13.367 15.6439 13.4775 15.5687 13.518 15.5396C13.5585 15.5104 13.5945 15.4865 13.598 15.4865C13.6015 15.4865 14.5458 16.4281 15.6964 17.5789C17.8031 19.686 17.8553 19.737 17.9884 19.8162C18.3586 20.0365 18.8396 20.0595 19.2351 19.8757C19.4965 19.7543 19.7562 19.4946 19.8776 19.2332C20.061 18.8385 20.0379 18.356 19.818 17.9865C19.7389 17.8535 19.6879 17.8013 17.5808 15.6945C16.43 14.5439 15.4884 13.5997 15.4884 13.5961C15.4884 13.5926 15.5123 13.5566 15.5414 13.5161C15.7821 13.1822 16.0292 12.7679 16.2319 12.3584C16.8245 11.1613 17.1203 9.89597 17.1203 8.55852C17.1203 7.21796 16.8232 5.95008 16.2279 4.75052C15.8091 3.90663 15.2849 3.17815 14.6128 2.50606C13.9404 1.8336 13.2115 1.30903 12.369 0.89126C11.2832 0.352788 10.1598 0.0622765 8.94839 0.00670048C8.74754 -0.00251552 8.35098 -0.00217152 8.14439 0.00740448ZM8.35239 2.67116C7.20874 2.70679 6.09237 3.08442 5.14757 3.75524C4.62973 4.12292 4.1248 4.62785 3.75712 5.14569C3.084 6.09372 2.70746 7.20968 2.67351 8.35725C2.64307 9.38588 2.84598 10.307 3.30485 11.2234C3.67525 11.9631 4.25066 12.6635 4.92324 13.1933C5.78954 13.8756 6.84643 14.3052 7.93639 14.418C8.32628 14.4584 8.79755 14.4583 9.18439 14.4179C10.2789 14.3035 11.3307 13.8761 12.1975 13.1933C12.5489 12.9166 12.9184 12.547 13.1952 12.1957C13.878 11.3288 14.3054 10.2771 14.4198 9.18252C14.4603 8.79528 14.4603 8.32176 14.4198 7.93452C14.3457 7.22517 14.1479 6.55594 13.8174 5.89668C13.3628 4.98968 12.6322 4.1777 11.7602 3.61041C10.8925 3.04588 9.81502 2.70236 8.82439 2.67441C8.74299 2.67212 8.64579 2.66913 8.60839 2.66777C8.57099 2.66642 8.45579 2.66795 8.35239 2.67116Z",
                    fill: fill
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_2367_13371",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeaderSearch);


/***/ }),

/***/ 18138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var BreadCrumbArrow = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.557 2.67311C5.43361 2.69613 5.32045 2.77137 5.25001 2.87723C5.20047 2.95168 5.17989 3.01695 5.17636 3.11082C5.17199 3.22681 5.19204 3.30295 5.25091 3.39399C5.26614 3.41752 5.75502 3.90878 7.5576 5.71185L9.84498 7.99985L7.5576 10.2879C5.75502 12.0909 5.26614 12.5822 5.25091 12.6057C5.19204 12.6968 5.17199 12.7729 5.17636 12.8889C5.17896 12.9579 5.18893 13.0034 5.21347 13.0579C5.26381 13.1698 5.37402 13.27 5.49032 13.3095C5.59721 13.3459 5.73841 13.3389 5.83633 13.2924C5.92155 13.2519 5.7554 13.4152 8.27956 10.891C9.62615 9.54438 10.6303 8.537 10.6468 8.51612C10.8436 8.26702 10.882 7.92846 10.7457 7.64359C10.7179 7.58549 10.6842 7.53099 10.6468 7.48359C10.6303 7.46271 9.62615 6.45533 8.27956 5.10871C6.23381 3.06291 5.93645 2.76711 5.90463 2.74629C5.82035 2.69112 5.75534 2.67081 5.65514 2.66833C5.61039 2.66722 5.58087 2.66866 5.557 2.67311Z",
            fill: "#A9AEB1"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumbArrow);


/***/ }),

/***/ 1967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89961);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10712);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var LinkTag = function(param) {
    var href = param.href, _target = param.target, target = _target === void 0 ? "_self" : _target, children = param.children, style = param.style, onClickNavigateToScreen = param.onClickNavigateToScreen, wrapperStyle = param.wrapperStyle, className = param.className;
    return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .isWebView */ .vp)() ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        className: className,
        role: "button",
        onClick: onClickNavigateToScreen,
        style: wrapperStyle,
        children: children
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        style: style,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
            target: target,
            style: style,
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LinkTag);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1aad4008-0"
})(_templateObject());


/***/ }),

/***/ 20265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _components_atom_images_DoctornowImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87522);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89961);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: flex;\n    flex-direction: column;\n    & > p {\n      ",
        "\n      color: ",
        ";\n    }\n    & > span {\n      ",
        "\n      color: ",
        ";\n      margin-top: 2px;\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 38px;\n  height: 38px;\n  margin-left: 20px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var MedicalCategory = function(param) {
    var name = param.name, description = param.description, imageUrl = param.imageUrl, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CategoryWrapper, {
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CategoryInfo, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                        children: name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CategoryImageWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_images_DoctornowImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    src: imageUrl,
                    width: 38,
                    height: 38,
                    loading: "eager",
                    alt: name
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MedicalCategory);
var CategoryWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-8d49df0e-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.client.isMobile ? "20px 24px 24px" : "20px 12px";
});
var CategoryInfo = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8d49df0e-1"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), theme.typography.UI18SB, theme.color.gray900, theme.typography.UI16R, theme.color.gray500);
});
var CategoryImageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8d49df0e-2"
})(_templateObject3());


/***/ }),

/***/ 26093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ Urls; },
/* harmony export */   "s": function() { return /* binding */ OutLinks; }
/* harmony export */ });
/**
 * @deprecated
 * 외부 링크 -> OutLinks
 * 내부 링크 -> types/common.ts
 */ var Urls = {
    Introduce: "/",
    Qna: "/content/qna",
    QnaCategory: "/content/qna/category",
    QnaWrite: "/content/qna/write",
    QnaWriteComplete: "/content/qna/write/complete",
    Magazine: "/content/magazine",
    MagazineCategory: "/content/magazine/category",
    MagazineTag: "/content/magazine/tag",
    MyPage: "/content/mypage",
    Hospital: "/hospitals",
    Error: "/content/error"
};
var OutLinks = {
    Contact: "https://company.doctornow.co.kr/contact/",
    Service: "https://company.doctornow.co.kr/service",
    Notice: "https://company.doctornow.co.kr/notice",
    Career: "https://company.doctornow.co.kr/career",
    Company: "https://company.doctornow.co.kr/company",
    Culture: "https://company.doctornow.co.kr/culture",
    Partnership: "https://company.doctornow.co.kr/partnership",
    StockConfirmInfo: "https://company.doctornow.co.kr/%eb%82%98%ec%9a%b0%ec%95%bd%ea%b5%ad-%ed%99%8d"
};


/***/ }),

/***/ 11304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rw": function() { return /* binding */ useMedicalCategoriesQuery; },
/* harmony export */   "em": function() { return /* binding */ useFaceToFaceTreatmentKeywordsQuery; }
/* harmony export */ });
/* unused harmony exports MedicalCategoriesDocument, FaceToFaceTreatmentKeywordsDocument */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36492);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);


var MedicalCategoriesDocument = "\n    query MedicalCategories($request: MedicalCategoryRequestInput!) {\n  medicalCategories(request: $request) {\n    id\n    name\n    description\n    iconUrl\n    inflowType\n    label\n    departmentGroupId\n    iconType\n    medicalSubCategories {\n      id\n      name\n      searchInflowType\n      nonBenefitCategoryId\n      nonBenefitItemId\n      prescriptionUnit\n      keyword\n    }\n  }\n}\n    ";
var useMedicalCategoriesQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "MedicalCategories",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(MedicalCategoriesDocument, "MedicalCategories", variables), options);
};
useMedicalCategoriesQuery.getKey = function(variables) {
    return [
        "MedicalCategories",
        variables
    ];
};
useMedicalCategoriesQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(MedicalCategoriesDocument, "MedicalCategories", variables, options);
};
var FaceToFaceTreatmentKeywordsDocument = "\n    query FaceToFaceTreatmentKeywords {\n  faceToFaceTreatmentKeywords {\n    id\n    name\n  }\n}\n    ";
var useFaceToFaceTreatmentKeywordsQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(variables === undefined ? [
        "FaceToFaceTreatmentKeywords"
    ] : [
        "FaceToFaceTreatmentKeywords",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(FaceToFaceTreatmentKeywordsDocument, "FaceToFaceTreatmentKeywords", variables), options);
};
useFaceToFaceTreatmentKeywordsQuery.getKey = function(variables) {
    return variables === undefined ? [
        "FaceToFaceTreatmentKeywords"
    ] : [
        "FaceToFaceTreatmentKeywords",
        variables
    ];
};
useFaceToFaceTreatmentKeywordsQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(FaceToFaceTreatmentKeywordsDocument, "FaceToFaceTreatmentKeywords", variables, options);
};


/***/ }),

/***/ 21586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22970);
/* harmony import */ var _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72271);
/* harmony import */ var _hospitalMain_gql_impl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11304);






var parseMedicalCategoriesVo = function(data) {
    var getCategoryIconType = function(iconType) {
        switch(iconType){
            case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__/* .MedicalCategoryIconType.Animation */ .Gjj.Animation:
                return "ANIMATION";
            case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__/* .MedicalCategoryIconType.PlainImage */ .Gjj.PlainImage:
            default:
                return "PLAIN_IMAGE";
        }
    };
    return data.medicalCategories.map(function(data) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data), {
            iconType: getCategoryIconType(data.iconType)
        });
    });
};
var useMedicalCategories = function(param) {
    var sortType = param.sortType, _enabled = param.enabled, enabled = _enabled === void 0 ? true : _enabled;
    var data = (0,_hospitalMain_gql_impl__WEBPACK_IMPORTED_MODULE_1__/* .useMedicalCategoriesQuery */ .Rw)({
        request: {
            sortType: sortType
        }
    }, {
        select: parseMedicalCategoriesVo,
        enabled: enabled
    }).data;
    return {
        data: data
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useMedicalCategories);
useMedicalCategories.prefetchQuery = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(queryClient, sortType) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.prefetchQuery(_hospitalMain_gql_impl__WEBPACK_IMPORTED_MODULE_1__/* .useMedicalCategoriesQuery.getKey */ .Rw.getKey({
                            request: {
                                sortType: sortType
                            }
                        }), _hospitalMain_gql_impl__WEBPACK_IMPORTED_MODULE_1__/* .useMedicalCategoriesQuery.fetcher */ .Rw.fetcher({
                            request: {
                                sortType: sortType
                            }
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient, sortType) {
        return _ref.apply(this, arguments);
    };
}();
useMedicalCategories.fetchQuery = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(queryClient, sortType) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.fetchQuery(_hospitalMain_gql_impl__WEBPACK_IMPORTED_MODULE_1__/* .useMedicalCategoriesQuery.getKey */ .Rw.getKey({
                            request: {
                                sortType: sortType
                            }
                        }), _hospitalMain_gql_impl__WEBPACK_IMPORTED_MODULE_1__/* .useMedicalCategoriesQuery.fetcher */ .Rw.fetcher({
                            request: {
                                sortType: sortType
                            }
                        }))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        parseMedicalCategoriesVo(response)
                    ];
            }
        });
    });
    return function(queryClient, sortType) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 77196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12436);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78287);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10712);






var useCustomRouter = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var moveToPage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(param) {
        var webLink = param.webLink, mobileScreenName = param.mobileScreenName, params = param.params, as = param.as, _type = param.type, type = _type === void 0 ? _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */ .nn.MOVE_TO_PAGE : _type;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .isWebView */ .vp)()) {
            (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .sendPostMessageToNative */ .T0)(type, {
                screenName: mobileScreenName,
                params: params ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params) : undefined
            });
        } else {
            if (!webLink) return;
            if (type === _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .NATIVE_POST_MESSAGE_TYPE.REPLACE_TO_PAGE */ .nn.REPLACE_TO_PAGE) {
                router.replace(webLink, as);
                return;
            }
            router.push(webLink, as);
        }
    }, [
        router
    ]);
    var getCustomPageName = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(defaultPageName) {
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .isWebView */ .vp)() ? defaultPageName : (0,_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .getMobileWebPageName */ .b9)(router);
    }, [
        router
    ]);
    var pageName = (0,_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .getPageName */ .j0)(router);
    return {
        router: router,
        moveToPage: lodash_throttle__WEBPACK_IMPORTED_MODULE_0___default()(moveToPage, 1500, {
            trailing: false
        }),
        getCustomPageName: getCustomPageName,
        pageName: pageName
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCustomRouter);


/***/ }),

/***/ 6608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ hospitals; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(83651);
// EXTERNAL MODULE: ./src/components/templates/f2f/common/hospital-notice-popup/index.tsx
var hospital_notice_popup = __webpack_require__(30683);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/BreadCrumbs.tsx
var BreadCrumbs = __webpack_require__(27441);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/molecules/sticky-app-header/index.tsx + 3 modules
var sticky_app_header = __webpack_require__(83025);
// EXTERNAL MODULE: ./src/constants/f2f/index.ts
var f2f = __webpack_require__(93247);
// EXTERNAL MODULE: ./src/hooks/cuj/useAppDownloadCujModal.tsx + 1 modules
var useAppDownloadCujModal = __webpack_require__(11989);
// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/types/hospital.ts
var hospital = __webpack_require__(24396);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
// EXTERNAL MODULE: ./src/constants/pixel.ts
var pixel = __webpack_require__(4380);
// EXTERNAL MODULE: ./src/hooks/useModal.tsx
var useModal = __webpack_require__(98266);
// EXTERNAL MODULE: ./src/types/modal.ts
var modal = __webpack_require__(74701);
// EXTERNAL MODULE: ./src/utils/pixel/pixel.ts
var pixel_pixel = __webpack_require__(5863);
// EXTERNAL MODULE: ./src/utils/validate.ts
var validate = __webpack_require__(64002);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./src/hooks/hospital/main/hospitalMain.gql.impl.tsx
var hospitalMain_gql_impl = __webpack_require__(11304);
;// CONCATENATED MODULE: ./src/hooks/hospital/main/useFaceToFaceTreatmentKeywords.ts




var parseHospitalTreatmentVo = function(data) {
    return data.faceToFaceTreatmentKeywords.map(function(data) {
        return (0,_object_spread/* default */.Z)({}, data);
    });
};
var useFaceToFaceTreatmentKeywords = function() {
    var data = (0,hospitalMain_gql_impl/* useFaceToFaceTreatmentKeywordsQuery */.em)(undefined, {
        select: parseHospitalTreatmentVo
    }).data;
    return {
        data: data
    };
};
/* harmony default export */ var main_useFaceToFaceTreatmentKeywords = (useFaceToFaceTreatmentKeywords);
useFaceToFaceTreatmentKeywords.prefetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.prefetchQuery(hospitalMain_gql_impl/* useFaceToFaceTreatmentKeywordsQuery.getKey */.em.getKey(), hospitalMain_gql_impl/* useFaceToFaceTreatmentKeywordsQuery.fetcher */.em.fetcher())
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/hooks/hospital/main/useMedicalCategories.ts
var useMedicalCategories = __webpack_require__(21586);
;// CONCATENATED MODULE: ./src/hooks/hospital/main/useHospitalHomeViewModel.ts















var MOBILE_CATEGORY_COUNT = 14;
var WEB_CATEGORY_COUNT = 15;
var useHospitalHomeViewModel = function(param) {
    var client = param.client;
    var ref = (0,useCustomRouter/* default */.Z)(), moveToPage = ref.moveToPage, router = ref.router, pageName = ref.pageName;
    var ref1 = (0,useModal/* default */.Z)(), showModal = ref1.showModal, closeModal = ref1.closeModal;
    var departmentGroupId = router.query.departmentGroupId;
    var ref2 = main_useFaceToFaceTreatmentKeywords(), tmp = ref2.data, treatments = tmp === void 0 ? [] : tmp;
    var ref3 = (0,useMedicalCategories/* default */.Z)({
        sortType: gql_schema/* MedicalCategorySortType.Recommendation */.eAd.Recommendation
    }), tmp1 = ref3.data, categories = tmp1 === void 0 ? [] : tmp1;
    var homeDiagnosisCategories = client.isMobile ? categories.slice(0, MOBILE_CATEGORY_COUNT) : categories.slice(0, WEB_CATEGORY_COUNT);
    var ref4 = (0,useMedicalCategories/* default */.Z)({
        sortType: gql_schema/* MedicalCategorySortType.Alphabet */.eAd.Alphabet,
        enabled: !client.isMobile
    }), tmp2 = ref4.data, allCategories = tmp2 === void 0 ? [] : tmp2;
    var ref5 = (0,react.useState)(false), isCategoriesModalOpen = ref5[0], setIsCategoriesModalOpen = ref5[1];
    var ref6 = (0,react.useState)(false), isTreatmentsModalOpen = ref6[0], setIsTreatmentsModalOpen = ref6[1];
    var setIsCujModalTrackingInfo = (0,useAppDownloadCujModal/* default */.Z)().setIsCujModalTrackingInfo;
    var navigateToNearSearchHospitalsFromKeyword = function(keyword, type) {
        var isCategoryType = type === "category";
        (0,logger/* faceTofaceLogger */.vS)({
            eventName: isCategoryType ? f2f/* FaceToFaceLog.click_category */.Gg.click_category : f2f/* FaceToFaceLog.click_category_treatment */.Gg.click_category_treatment,
            pageName: pageName,
            payload: {
                keyword: keyword
            }
        });
        moveToPage({
            mobileScreenName: common/* ROUTES.HOSPITAL.SEARCH.appScreenName */.Z6.HOSPITAL.SEARCH.appScreenName,
            webLink: "".concat(common/* ROUTES.HOSPITAL.SEARCH.path */.Z6.HOSPITAL.SEARCH.path, "?").concat(hospital/* HospitalSearchParamsQueries.Keyword */.UG.Keyword, "=").concat(keyword, "&").concat(hospital/* HospitalSearchParamsQueries.Mode */.UG.Mode, "=NEAR&").concat(hospital/* HospitalSearchParamsQueries.SortType */.UG.SortType, "=DISTANCE"),
            params: {
                keyword: keyword,
                mode: "NEAR",
                sortType: "DISTANCE"
            }
        });
    };
    var navigateToSearchHospitalsFromKeyword = function(keyword) {
        if (!(0,validate/* validateNonSpecialPattern */.G5)(keyword)) {
            showModal({
                type: modal/* MODAL_TYPE.ALERT */.f.ALERT,
                props: {
                    title: "특수문자를 지원하지 않아요.",
                    message: "다른 검색어를 입력해주세요.",
                    buttons: [
                        {
                            type: modal/* MODAL_BUTTON_TYPE.BOLD */.J.BOLD,
                            label: "확인",
                            onClick: closeModal
                        }
                    ]
                }
            });
            return;
        }
        (0,logger/* faceTofaceLogger */.vS)({
            eventName: f2f/* FaceToFaceLog.click_search_keyword */.Gg.click_search_keyword,
            pageName: pageName,
            payload: {
                keyword: keyword
            }
        });
        moveToPage({
            mobileScreenName: common/* ROUTES.HOSPITAL.SEARCH.appScreenName */.Z6.HOSPITAL.SEARCH.appScreenName,
            webLink: "".concat(common/* ROUTES.HOSPITAL.SEARCH.path */.Z6.HOSPITAL.SEARCH.path, "?").concat(hospital/* HospitalSearchParamsQueries.Keyword */.UG.Keyword, "=").concat(keyword),
            params: {
                keyword: keyword
            }
        });
    };
    var openMedicalCategories = function() {
        if (client.isMobile) {
            moveToPage({
                mobileScreenName: common/* ROUTES.HOSPITAL.CATEGORIES.appScreenName */.Z6.HOSPITAL.CATEGORIES.appScreenName,
                webLink: common/* ROUTES.HOSPITAL.CATEGORIES.path */.Z6.HOSPITAL.CATEGORIES.path
            });
            return;
        }
        setIsCategoriesModalOpen(true);
    };
    var closeMedicalCategories = function() {
        setIsCategoriesModalOpen(false);
    };
    var openHospitalTreatments = function() {
        if (client.isMobile) {
            moveToPage({
                mobileScreenName: common/* ROUTES.HOSPITAL.TREATMENTS.appScreenName */.Z6.HOSPITAL.TREATMENTS.appScreenName,
                webLink: common/* ROUTES.HOSPITAL.TREATMENTS.path */.Z6.HOSPITAL.TREATMENTS.path
            });
            return;
        }
        setIsTreatmentsModalOpen(true);
    };
    var closeHospitalTreatments = function() {
        setIsTreatmentsModalOpen(false);
    };
    var clickCategory = function(category) {
        navigateToNearSearchHospitalsFromKeyword(category.name, "category");
    };
    (0,react.useEffect)(function() {
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.PageIn */.$.PageIn, {});
        setIsCujModalTrackingInfo({
            campaignName: "web_hospitals",
            trackContent: "web_mid_mdl_main"
        });
    }, []);
    return {
        categories: homeDiagnosisCategories,
        treatments: treatments,
        navigateToSearchHospitalsFromKeyword: navigateToSearchHospitalsFromKeyword,
        navigateToNearSearchHospitalsFromKeyword: navigateToNearSearchHospitalsFromKeyword,
        isCategoriesModalOpen: isCategoriesModalOpen,
        isTreatmentsModalOpen: isTreatmentsModalOpen,
        openMedicalCategories: openMedicalCategories,
        closeMedicalCategories: closeMedicalCategories,
        openHospitalTreatments: openHospitalTreatments,
        closeHospitalTreatments: closeHospitalTreatments,
        allCategories: allCategories,
        clickCategory: clickCategory,
        departmentGroupId: departmentGroupId
    };
};
/* harmony default export */ var main_useHospitalHomeViewModel = (useHospitalHomeViewModel);

// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
;// CONCATENATED MODULE: ./src/components/atom/icon/DepartmentEventIcon.tsx


var DepartmentEventIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "35",
        height: "15",
        viewBox: "0 0 35 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "35",
                height: "15",
                rx: "7.5",
                fill: "#F76707"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.0869 7.77344V8.51562H22.9932V3.83789H28.999V4.58984H23.9307V5.77148H28.8135V6.50391H23.9307V7.77344H29.0869ZM29.9951 10V10.7617H21.9873V10H29.9951Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.8057 3.11523V9.75586H19.9268V3.11523H20.8057ZM19.0967 3.27148V9.48242H18.2178V6.36719H17.1436V8.13477H13.7158V3.80859H14.5947V5.24414H16.2842V3.80859H17.1436V5.61523H18.2178V3.27148H19.0967ZM14.5947 7.38281H16.2842V5.95703H14.5947V7.38281ZM21.0596 10.9277V11.6797H15.0049V8.85742H15.9229V10.9277H21.0596Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.9482 3.11523V11.8848H11.0205V3.11523H11.9482ZM7.27051 3.76953C8.56934 3.76953 9.52637 4.96094 9.52637 6.83594C9.52637 8.7207 8.56934 9.91211 7.27051 9.91211C5.95215 9.91211 5.00488 8.7207 5.00488 6.83594C5.00488 4.96094 5.95215 3.76953 7.27051 3.76953ZM7.27051 4.59961C6.45996 4.59961 5.90332 5.45898 5.90332 6.83594C5.90332 8.22266 6.45996 9.08203 7.27051 9.08203C8.07129 9.08203 8.62793 8.22266 8.62793 6.83594C8.62793 5.45898 8.07129 4.59961 7.27051 4.59961Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var icon_DepartmentEventIcon = (DepartmentEventIcon);

// EXTERNAL MODULE: ./src/components/atom/icon/HeaderSearch.tsx
var HeaderSearch = __webpack_require__(70253);
// EXTERNAL MODULE: ./src/components/atom/images/DoctornowImage.tsx
var DoctornowImage = __webpack_require__(87522);
// EXTERNAL MODULE: ./src/components/common/link-tag/index.tsx
var link_tag = __webpack_require__(1967);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(4611);
;// CONCATENATED MODULE: ./src/components/templates/f2f/hospital/hospitals-home-template/find-hospital-categories/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 0 24px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    display: flex;\n    align-items: center;\n    padding: 0 24px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    display: flex;\n    align-items: center;\n    padding: 0 24px;\n    margin-top: 4px;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        ";\n      @media screen and (max-width: ",
        ") {\n        ",
        "\n      }\n      color: ",
        ";\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  align-self: stretch;\n\n  & > h3 {\n    ",
        "\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    flex-wrap: wrap;\n    overflow: hidden;\n    padding: 0 24px;\n    text-wrap: nowrap;\n    row-gap: 8px;\n    @media screen and (min-width: ",
        ") {\n      column-gap: 12px;\n    }\n    margin-top: ",
        ";\n    grid-template-columns: ",
        ";\n    grid-template-rows: ",
        ";\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: ",
        "px;\n  top: ",
        "px;\n  z-index: 1;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    &::placeholder {\n      ",
        "\n      color: ",
        ";\n    }\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 0 48px 0 16px;\n  height: 48px;\n  border-radius: 8px;\n  border: none;\n  outline: none;\n  background-color: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 24px;\n  margin-bottom: 24px;\n  position: relative;\n  width: 100%;\n  height: 48px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 28px;\n  height: 28px;\n  right: 36px;\n  top: 50%;\n  transform: translateY(-50%);\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}












var FindHospitalCategories = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: children
    });
};
/* harmony default export */ var find_hospital_categories = (FindHospitalCategories);
var Title = function(param) {
    var text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FindHospitalTitle, {
        children: text
    });
};
var SupportText = function(param) {
    var text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FindHospitalSupportText, {
        children: text
    });
};
var Categories = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesWrapper, {
        children: children
    });
};
var Category = function(param) {
    var category = param.category, onClick = param.onClick, isMobile = param.isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(link_tag/* default */.Z, {
        href: "".concat(common/* ROUTES.HOSPITAL.NEIGHBORHOOD.path */.Z6.HOSPITAL.NEIGHBORHOOD.path, "?keyword=").concat(category.name, "&regionCode=11&type=all"),
        onClickNavigateToScreen: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryWrapper, {
            children: [
                (0,format/* isEventLabel */.JH)(category) && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventIconWrapper, {
                    isMobile: isMobile,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_DepartmentEventIcon, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        padding: "20%",
                        width: "100%",
                        height: "100%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctornowImage/* default */.Z, {
                        className: "department-image h-full w-full",
                        src: category.iconUrl,
                        loading: "eager",
                        alt: category.name,
                        objectFit: "contain"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    children: category.name
                })
            ]
        })
    });
};
var MoreSee = function(param) {
    var text = param.text, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MoreSeeButton, {
        type: "button",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    padding: "20%",
                    width: "100%",
                    height: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctornowImage/* default */.Z, {
                    className: "department-image h-full w-full",
                    src: "https://media.doctornow.co.kr/f2f_all_category.png",
                    loading: "eager",
                    alt: "전체보기",
                    objectFit: "contain"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: text
            })
        ]
    });
};
var Search = function(param) {
    var onSubmit = param.onSubmit;
    var ref = (0,useModal/* default */.Z)(), showModal = ref.showModal, closeModal = ref.closeModal;
    var ref1 = (0,react.useState)(""), keyword = ref1[0], setKeyword = ref1[1];
    var onChange = function(e) {
        var value = e.target.value;
        setKeyword(value);
    };
    var submitSearch = function() {
        var inputKeyword = keyword.trim();
        if (!inputKeyword) {
            showModal({
                type: modal/* MODAL_TYPE.ALERT */.f.ALERT,
                props: {
                    title: "검색어를 입력해주세요.",
                    buttons: [
                        {
                            type: modal/* MODAL_BUTTON_TYPE.BOLD */.J.BOLD,
                            label: "확인",
                            onClick: function() {
                                return closeModal();
                            }
                        }, 
                    ]
                }
            });
            return;
        }
        if (inputKeyword.length < 2) {
            showModal({
                type: modal/* MODAL_TYPE.ALERT */.f.ALERT,
                props: {
                    title: "2글자 이상 입력해 주세요.",
                    message: "더 정확도 높은 결과를 볼 수 있어요.",
                    buttons: [
                        {
                            type: modal/* MODAL_BUTTON_TYPE.BOLD */.J.BOLD,
                            label: "확인",
                            onClick: function() {
                                return closeModal();
                            }
                        }, 
                    ]
                }
            });
            return;
        }
        onSubmit(inputKeyword);
    };
    var pressEnterSubmit = function(e) {
        if (e.key !== "Enter") return;
        e.preventDefault();
        submitSearch();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput, {
                placeholder: "병원, 지역/지하철명+과목, 증상",
                value: keyword,
                onChange: onChange,
                onKeyDown: pressEnterSubmit
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchButton, {
                type: "button",
                onClick: submitSearch,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSearch/* default */.Z, {
                    size: 16,
                    fill: theme/* default.color.gray600 */.Z.color.gray600
                })
            })
        ]
    });
};
FindHospitalCategories.Title = Title;
FindHospitalCategories.SupportText = SupportText;
FindHospitalCategories.Categories = Categories;
FindHospitalCategories.Category = Category;
FindHospitalCategories.MoreSee = MoreSee;
FindHospitalCategories.Search = Search;
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-124d4702-0"
})(_templateObject());
var FindHospitalTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-124d4702-1"
})(_templateObject2(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), _$theme.typography.UI19SB, _$theme.color.gray700);
});
var FindHospitalSupportText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-124d4702-2"
})(_templateObject4(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), _$theme.typography.UI13R, _$theme.color.gray500);
});
var CategoryWrapper = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-124d4702-3"
})(_templateObject6(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), _$theme.typography.UI15M, _$theme.breakPoint.SMALL_MOBILE, _$theme.typography.UI13M, _$theme.color.gray800);
});
var CategoriesWrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-124d4702-4"
})(_templateObject8(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject7(), _$theme.breakPoint.SMALL_MOBILE, function() {
        var client = _$theme.client;
        if (client.isMobile) {
            return "12px";
        }
        return "14px";
    }, function() {
        var client = _$theme.client;
        if (client.isMobile) {
            return "repeat(5, minmax(calc(20% - 12px), auto));";
        }
        return "repeat(8, minmax(calc(12.5% - 12px), auto));";
    }, function() {
        var client = _$theme.client;
        if (client.isMobile) {
            return "1fr 1fr 1fr";
        }
        return "1fr 1fr";
    });
});
var MoreSeeButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-124d4702-5"
})(_templateObject9(), function(param) {
    var _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.UI15M, "\n    @media screen and (max-width: ").concat(_$theme.breakPoint.SMALL_MOBILE, ") {\n      ").concat(_$theme.typography.UI13M, "\n    }\n    color: ").concat(_$theme.color.gray800, ";\n  ");
});
var EventIconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-124d4702-6"
})(_templateObject10(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? 0 : 17;
}, function(param) {
    var isMobile = param.isMobile;
    return isMobile ? 0 : 5;
});
var SearchInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-124d4702-7"
})(_templateObject12(), theme/* default.color.gray30 */.Z.color.gray30, function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject11(), _$theme.typography.UI16M, _$theme.color.gray600, _$theme.typography.UI16R, _$theme.color.gray300);
});
var SearchWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-124d4702-8"
})(_templateObject13());
var SearchButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-124d4702-9"
})(_templateObject14());

;// CONCATENATED MODULE: ./src/components/templates/f2f/hospital/hospitals-home-template/find-hospital-treatments/index.tsx

function find_hospital_treatments_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    find_hospital_treatments_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function find_hospital_treatments_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    display: flex;\n    align-items: center;\n    padding: 0 24px;\n    height: 32px;\n    margin-top: 32px;\n  "
    ]);
    find_hospital_treatments_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function find_hospital_treatments_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    find_hospital_treatments_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function find_hospital_treatments_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  overflow: hidden;\n  gap: 8px;\n  padding: 0 24px;\n  margin-top: 24px;\n  margin-bottom: 80px;\n"
    ]);
    find_hospital_treatments_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function find_hospital_treatments_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: ",
        ";\n    height: 40px;\n    padding: 0 16px;\n    & > h3 {\n      ",
        "\n      color: ",
        ";\n    }\n  "
    ]);
    find_hospital_treatments_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function find_hospital_treatments_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 25px;\n"
    ]);
    find_hospital_treatments_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function find_hospital_treatments_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  padding: 16px 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    find_hospital_treatments_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}






var FindHospitalTreatments = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(find_hospital_treatments_Wrapper, {
        children: children
    });
};
var find_hospital_treatments_Title = function(param) {
    var text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FindTitle, {
        children: text
    });
};
var Treatments = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TreatmentsWrapper, {
        children: children
    });
};
var Treatment = function(param) {
    var text = param.text, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(link_tag/* default */.Z, {
        href: "".concat(common/* ROUTES.HOSPITAL.SEARCH.path */.Z6.HOSPITAL.SEARCH.path, "?").concat(hospital/* HospitalSearchParamsQueries.Keyword */.UG.Keyword, "=").concat(text, "&").concat(hospital/* HospitalSearchParamsQueries.Mode */.UG.Mode, "=NEAR&").concat(hospital/* HospitalSearchParamsQueries.SortType */.UG.SortType, "=DISTANCE"),
        onClickNavigateToScreen: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TreatmentWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: text
            })
        })
    });
};
var find_hospital_treatments_MoreSee = function(param) {
    var text = param.text, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(find_hospital_treatments_MoreSeeButton, {
        type: "button",
        onClick: onClick,
        children: text
    });
};
/* harmony default export */ var find_hospital_treatments = (FindHospitalTreatments);
FindHospitalTreatments.Title = find_hospital_treatments_Title;
FindHospitalTreatments.Treatments = Treatments;
FindHospitalTreatments.Treatment = Treatment;
FindHospitalTreatments.MoreSee = find_hospital_treatments_MoreSee;
var find_hospital_treatments_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-26c520cd-0"
})(find_hospital_treatments_templateObject());
var FindTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-26c520cd-1"
})(find_hospital_treatments_templateObject2(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(find_hospital_treatments_templateObject1(), theme.typography.UI19SB, theme.color.gray700);
});
var TreatmentsWrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-26c520cd-2"
})(find_hospital_treatments_templateObject3());
var TreatmentWrapper = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-26c520cd-3"
})(find_hospital_treatments_templateObject5(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(find_hospital_treatments_templateObject4(), theme.color.gray30, theme.typography.UI15M, theme.color.gray600);
});
var find_hospital_treatments_MoreSeeButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-26c520cd-4"
})(find_hospital_treatments_templateObject6(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI17M, "\n    color: ").concat(theme.color.gray500, ";\n    border-top: 1px solid ").concat(theme.color.gray50, ";\n    border-bottom: 1px solid ").concat(theme.color.gray50, ";\n");
});

// EXTERNAL MODULE: ./src/components/molecules/bottom-sheet/index.tsx + 5 modules
var bottom_sheet = __webpack_require__(5679);
// EXTERNAL MODULE: ./src/components/templates/f2f/common/medical-category/index.tsx
var medical_category = __webpack_require__(20265);
;// CONCATENATED MODULE: ./src/components/templates/f2f/hospital/hospitals-home-template/medical-categories-modal/index.tsx

function medical_categories_modal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 560px;\n    display: flex;\n    flex-direction: column;\n    padding: 16px 12px 28px;\n    & > h4 {\n      ",
        "\n      color: ",
        ";\n      padding: 0 12px;\n      margin-bottom: 16px;\n    }\n  "
    ]);
    medical_categories_modal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function medical_categories_modal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    medical_categories_modal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function medical_categories_modal_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  max-height: 610px;\n  overflow-y: scroll;\n"
    ]);
    medical_categories_modal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var MedicalCategoriesModal = function(param) {
    var categories = param.categories, toggleModal = param.toggleModal, client = param.client, onClick = param.onClick;
    if (client.isMobile) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(bottom_sheet/* default */.ZP, {
        index: 310,
        isOpened: true,
        onClickOverlay: toggleModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PcContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    children: "진료과목 선택"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesPCWrapper, {
                    children: categories.map(function(category) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(medical_category/* default */.Z, {
                            name: category.name,
                            imageUrl: category.iconUrl,
                            onClick: function() {
                                return onClick(category.name);
                            },
                            description: category.description
                        }, "medical-category-".concat(category.id));
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var medical_categories_modal = (MedicalCategoriesModal);
var PcContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d5903f15-0"
})(medical_categories_modal_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(medical_categories_modal_templateObject(), theme.typography.UI20SB, theme.color.gray800);
});
var CategoriesPCWrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-d5903f15-1"
})(medical_categories_modal_templateObject2());

;// CONCATENATED MODULE: ./src/components/templates/f2f/hospital/hospitals-home-template/index.tsx

function hospitals_home_template_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n"
    ]);
    hospitals_home_template_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function hospitals_home_template_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    display: flex;\n    align-items: center;\n    padding: 0 24px;\n    height: 60px;\n  "
    ]);
    hospitals_home_template_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function hospitals_home_template_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    hospitals_home_template_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function hospitals_home_template_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 16px;\n    background-color: ",
        ";\n  "
    ]);
    hospitals_home_template_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function hospitals_home_template_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    hospitals_home_template_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}












var HospitalsHomeTemplate = function(param) {
    var client = param.client;
    var viewModel = main_useHospitalHomeViewModel({
        client: client
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            client.isWebView && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.StickyHeader */.Z.StickyHeader, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sticky_app_header/* default */.Z, {
                    title: "가까운 병원 찾기"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                            visible: !client.isMobile,
                            type: "hospitals",
                            path: "".concat(common/* ROUTES.HOSPITAL.HOME.path */.Z6.HOSPITAL.HOME.path)
                        })
                    }),
                    client.clientType === app/* ClientType.WEB */.B.WEB && /*#__PURE__*/ (0,jsx_runtime.jsx)(hospitals_home_template_FindHospitalTitle, {
                        children: "가까운 병원 찾기"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(find_hospital_categories, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(find_hospital_categories.Search, {
                                onSubmit: function(keyword) {
                                    return viewModel.navigateToSearchHospitalsFromKeyword(keyword);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(find_hospital_categories.Title, {
                                text: "어떤 병원을 찾으세요?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(find_hospital_categories.SupportText, {
                                text: "예약하고 대기없이 편하게 방문해보세요"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(find_hospital_categories.Categories, {
                                children: [
                                    viewModel.categories.map(function(category) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(find_hospital_categories.Category, {
                                            category: category,
                                            isMobile: client.isMobile,
                                            onClick: function() {
                                                return viewModel.clickCategory(category);
                                            }
                                        }, "hospital-category-".concat(category.id, "}"));
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(find_hospital_categories.MoreSee, {
                                        text: "전체보기",
                                        onClick: viewModel.openMedicalCategories
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Division, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(find_hospital_treatments, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(find_hospital_treatments.Title, {
                                text: "어떻게 아프세요?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(find_hospital_treatments.Treatments, {
                                children: viewModel.treatments.map(function(treatment) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(find_hospital_treatments.Treatment, {
                                        text: "".concat(treatment.name),
                                        onClick: function() {
                                            return viewModel.navigateToNearSearchHospitalsFromKeyword(treatment.name, "treatment");
                                        }
                                    }, "hospital-treatment-".concat(treatment.id));
                                })
                            })
                        ]
                    })
                ]
            }),
            !client.isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: viewModel.isCategoriesModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(medical_categories_modal, {
                    client: client,
                    categories: viewModel.allCategories,
                    onClick: function(keyword) {
                        return viewModel.navigateToNearSearchHospitalsFromKeyword(keyword, "category");
                    },
                    toggleModal: viewModel.closeMedicalCategories
                })
            })
        ]
    });
};
/* harmony default export */ var hospitals_home_template = (HospitalsHomeTemplate);
var BreadCrumbsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c629051c-0"
})(hospitals_home_template_templateObject(), function(param) {
    var theme = param.theme;
    return theme.client.isMobile ? "0" : "24px 24px 0";
});
var hospitals_home_template_FindHospitalTitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-c629051c-1"
})(hospitals_home_template_templateObject2(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(hospitals_home_template_templateObject1(), theme.typography.UI22SB, theme.color.gray900);
});
var Division = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c629051c-2"
})(hospitals_home_template_templateObject4(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(hospitals_home_template_templateObject3(), theme.color.gray30);
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/recoil/es/index.js
var es = __webpack_require__(53476);
// EXTERNAL MODULE: ./src/recoil/atoms/common/popup.ts
var popup = __webpack_require__(17454);
// EXTERNAL MODULE: ./src/utils/date.ts
var date = __webpack_require__(30918);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(74735);
;// CONCATENATED MODULE: ./src/hooks/hospital/list/useHospitalNoticePopupViewModel.tsx












var useHospitalNoticePopupViewModel = function() {
    var router = (0,next_router.useRouter)();
    var pageName = (0,logger/* getPageName */.j0)(router);
    var ref = (0,_sliced_to_array/* default */.Z)((0,es.useRecoilState)(popup/* closedHospitalPopupDayState */.y), 2), closedHospitalPopupDay = ref[0], setClosedHospitalPopupDay = ref[1];
    var ref1 = (0,react.useState)(0), currentStep = ref1[0], setCurrentStep = ref1[1];
    var swiperRef = (0,react.useRef)(null);
    var isWebViewLink = (0,RNPlugins/* isWebView */.vp)();
    var hospitalPopupList = (0,react.useMemo)(function() {
        return [];
    }, [
        isWebViewLink
    ]);
    var isClosedTodayHospitalPopup = (0,react.useMemo)(function() {
        if (!closedHospitalPopupDay) return false;
        return (0,date/* isSameDate */.Fo)(closedHospitalPopupDay, "date");
    }, [
        closedHospitalPopupDay
    ]);
    var activePopupList = (0,react.useMemo)(function() {
        return hospitalPopupList.filter(function(popup) {
            return (0,date/* isBetweenDate */.Ut)({
                startAt: popup.startAt,
                endAt: popup.endAt,
                unitType: "minutes"
            });
        });
    }, [
        hospitalPopupList
    ]);
    var onChangeStep = function(step) {
        setCurrentStep(step);
    };
    var onClosePopupToday = function() {
        (0,logger/* faceTofaceLogger */.vS)({
            pageName: pageName,
            eventName: "click_hospital_popup_close_today"
        });
        var today = dayjs_min_default()().format();
        setClosedHospitalPopupDay(today);
    };
    var openLink = function(popup) {
        if (common/* isServer */.sk) {
            return;
        }
        onClosePopupToday();
        (0,logger/* faceTofaceLogger */.vS)({
            pageName: pageName,
            eventName: "hospital_popup_click",
            payload: {
                link: popup.link
            }
        });
        if (popup.isExternalLink) {
            if (isWebViewLink) {
                (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.OPEN_EXTERNAL_BROWSER */.nn.OPEN_EXTERNAL_BROWSER, {
                    url: popup.link
                });
                return;
            }
            window.open(popup.link);
            return;
        }
        if (isWebViewLink) {
            (0,RNPlugins/* sendPostMessageToNative */.T0)(popup.isSameRouter ? RNPlugins/* NATIVE_POST_MESSAGE_TYPE.REPLACE_TO_PAGE */.nn.REPLACE_TO_PAGE : RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */.nn.MOVE_TO_PAGE, (0,_object_spread/* default */.Z)({
                screenName: popup.link
            }, popup.payload && {
                params: (0,_object_spread/* default */.Z)({}, popup.payload)
            }));
            return;
        }
        router.push("".concat(popup.link).concat((0,url/* addQueryString */.sC)(popup.payload)));
    };
    var isClosedPopup = function() {
        return !activePopupList.length || isClosedTodayHospitalPopup;
    };
    var popupPageViewLogger = function() {
        (0,logger/* faceTofaceLogger */.vS)({
            pageName: pageName,
            eventName: "hospital_popup_view"
        });
    };
    return {
        swiperRef: swiperRef,
        activePopupList: activePopupList,
        currentStep: currentStep,
        isClosedPopup: isClosedPopup,
        onChangeStep: onChangeStep,
        onClosePopupToday: onClosePopupToday,
        openLink: openLink,
        popupPageViewLogger: popupPageViewLogger
    };
};
/* harmony default export */ var list_useHospitalNoticePopupViewModel = (useHospitalNoticePopupViewModel);

;// CONCATENATED MODULE: ./src/pages/hospitals/index.tsx
// PageDescription: 대면진료 병원 페이지








var HospitalsHomePage = function(param) {
    var client = param.client;
    var viewModel = list_useHospitalNoticePopupViewModel();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "병원 찾기 - 닥터나우",
                description: "내 근처 병원을 전국 76,614개 병원이 모인 닥터나우에서 찾아보세요! 위치부터 후기까지 확인 후, 예약할 수 있어요!",
                canonical: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.HOSPITAL.HOME.path */.Z6.HOSPITAL.HOME.path),
                openGraph: {
                    title: "병원 찾기 - 닥터나우",
                    description: "병원 위치부터 후기까지 확인 후, 예약해 보세요!",
                    images: [
                        {
                            url: "".concat("https://media.doctornow.co.kr/hospital_logo.png"),
                            alt: "Og Image Alt"
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hospitals_home_template, {
                client: client
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hospital_notice_popup/* default */.Z, {
                enabled: client.isWebView,
                viewModel: viewModel
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var hospitals = (HospitalsHomePage);
HospitalsHomePage.Layout = DefaultLayout/* default */.Z;


/***/ }),

/***/ 45162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tq": function() { return /* binding */ AuthorType; },
/* harmony export */   "Zg": function() { return /* binding */ MagazineTagType; },
/* harmony export */   "pO": function() { return /* binding */ EDoctorCareer; },
/* harmony export */   "rL": function() { return /* binding */ MagazineType; },
/* harmony export */   "wK": function() { return /* binding */ MagazineBottomButtonType; }
/* harmony export */ });
/* unused harmony export CoreCategoryType */
var MagazineType = {
    INTERNAL: "INTERNAL",
    EXTERNAL: "EXTERNAL",
    ARTICLE: "ARTICLE",
    FAQ: "FAQ"
};
var MagazineTagType;
(function(MagazineTagType) {
    MagazineTagType["DEPARTMENT"] = "DEPARTMENT";
    MagazineTagType["SYMPTOM"] = "SYMPTOM";
    MagazineTagType["DISEASE"] = "DISEASE";
    MagazineTagType["FREE"] = "FREE";
})(MagazineTagType || (MagazineTagType = {}));
var CoreCategoryType;
(function(CoreCategoryType) {
    CoreCategoryType["Department"] = "DEPARTMENT";
    CoreCategoryType["Disease"] = "DISEASE";
    CoreCategoryType["Symptom"] = "SYMPTOM";
})(CoreCategoryType || (CoreCategoryType = {}));
var AuthorType;
(function(AuthorType) {
    AuthorType["DOCTOR"] = "DOCTOR";
    AuthorType["AI"] = "AI";
    AuthorType["NURSE"] = "NURSE";
    AuthorType["MEDICAL_PROFESSIONAL_EDITOR"] = "MEDICAL_PROFESSIONAL_EDITOR";
    AuthorType["GENERAL_EDITOR"] = "GENERAL_EDITOR";
})(AuthorType || (AuthorType = {}));
var ProfessionalFieldType;
(function(ProfessionalFieldType) {
    ProfessionalFieldType["DEPARTMENT"] = "DEPARTMENT";
})(ProfessionalFieldType || (ProfessionalFieldType = {}));
var MagazineBottomButtonType;
(function(MagazineBottomButtonType) {
    MagazineBottomButtonType["QUESTION"] = "QUESTION";
    MagazineBottomButtonType["DIAGNOSIS"] = "DIAGNOSIS";
})(MagazineBottomButtonType || (MagazineBottomButtonType = {}));
var EDoctorCareer;
(function(EDoctorCareer) {
    EDoctorCareer["CURRENT"] = "CURRENT";
    EDoctorCareer["PAST"] = "PAST";
    EDoctorCareer["GRADUATION"] = "GRADUATION";
    EDoctorCareer["COMPLETION"] = "COMPLETION";
})(EDoctorCareer || (EDoctorCareer = {}));


/***/ }),

/***/ 64002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B9": function() { return /* binding */ preventInputEnter; },
/* harmony export */   "G5": function() { return /* binding */ validateNonSpecialPattern; },
/* harmony export */   "G6": function() { return /* binding */ checkInputOnlyNumber; },
/* harmony export */   "SO": function() { return /* binding */ pressEnterNextFocus; },
/* harmony export */   "Zr": function() { return /* binding */ validateSsnCheck; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var getIsNation = function(ssn2) {
    var secondFirstPlace = ssn2.substring(0, 1);
    switch(secondFirstPlace){
        case "5":
        case "6":
        case "7":
        case "8":
            return true;
        default:
            return false;
    }
};
var validateSsnCheck = function(_ssn1, _ssn2, isSsnChanged) {
    var ssn1 = _ssn1, ssn2 = _ssn2, ssn = ssn1 + "" + ssn2, arrSsn = [], compare = [
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        2,
        3,
        4,
        5
    ];
    var sum = 0;
    if (ssn.length !== 13) return false;
    if (isSsnChanged) {
        return true;
    }
    var secondFirstPlace = ssn2.substring(0, 1);
    if (ssn1 >= "201001" && [
        "3",
        "4"
    ].includes(secondFirstPlace)) {
        return true;
    }
    for(var i = 0; i < 13; i++){
        arrSsn[i] = Number(ssn.substring(i, i + 1));
    }
    for(var i1 = 0; i1 < 12; i1++){
        sum = sum + arrSsn[i1] * compare[i1];
    }
    var isNation = getIsNation(ssn2);
    if (isNation) {
        sum = (13 - sum % 11) % 10;
    } else {
        sum = (11 - sum % 11) % 10;
    }
    if (sum !== arrSsn[12]) return false;
    return true;
};
var preventInputEnter = function(event) {
    if (event.key === "Enter") {
        event.preventDefault();
        return true;
    }
    return false;
};
var pressEnterNextFocus = function(event, nextElement) {
    var isPrevented = preventInputEnter(event);
    if (!nextElement || !isPrevented) {
        return;
    }
    nextElement.focus();
};
var checkInputOnlyNumber = function(event) {
    var notNumberRegex = /[^0-9]/g;
    var hasNotNumberChar = event.target.value.match(notNumberRegex);
    if (!hasNotNumberChar) {
        return;
    }
    event.target.value = event.target.value.replace(notNumberRegex, "");
};
var validateNonSpecialPattern = function(input) {
    var ALLOWED_PATTERN = /^[a-zA-Z0-9가-힣\s]*$/gi;
    return ALLOWED_PATTERN.test(input);
};


/***/ }),

/***/ 83464:
/***/ (function(module) {

"use strict";
module.exports = cacheable-lookup;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7041,6492,9097,7506,8391,2271,9653,3158,4611,5679,1790,9774,2888,179], function() { return __webpack_exec__(40307); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);